// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-color-picker-edit {
  display: flex;
  margin-top: 24px;
}

:where(.vuetify-styles) .v-color-picker-edit__input {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
}
:where(.vuetify-styles) .v-color-picker-edit__input > input::-webkit-outer-spin-button,
:where(.vuetify-styles) .v-color-picker-edit__input > input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
:where(.vuetify-styles) .v-color-picker-edit__input:not(:last-child) {
  margin-inline-end: 8px;
}
:where(.vuetify-styles) .v-color-picker-edit__input input {
  border-radius: 4px;
  margin-bottom: 8px;
  min-width: 0;
  outline: none;
  text-align: center;
  width: 100%;
  height: 32px;
  background: rgba(var(--v-theme-surface-variant), 0.2);
  color: rgba(var(--v-theme-on-surface));
}
@media (forced-colors: active) {
  :where(.vuetify-styles) .v-color-picker-edit__input input {
    border-style: solid;
  }
}
:where(.vuetify-styles) .v-color-picker-edit__input span {
  font-size: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VColorPicker/VColorPickerEdit.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,sCAAsC;AACxC;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".v-color-picker-edit {\n  display: flex;\n  margin-top: 24px;\n}\n\n.v-color-picker-edit__input {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  text-align: center;\n}\n.v-color-picker-edit__input > input::-webkit-outer-spin-button,\n.v-color-picker-edit__input > input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.v-color-picker-edit__input:not(:last-child) {\n  margin-inline-end: 8px;\n}\n.v-color-picker-edit__input input {\n  border-radius: 4px;\n  margin-bottom: 8px;\n  min-width: 0;\n  outline: none;\n  text-align: center;\n  width: 100%;\n  height: 32px;\n  background: rgba(var(--v-theme-surface-variant), 0.2);\n  color: rgba(var(--v-theme-on-surface));\n}\n@media (forced-colors: active) {\n  .v-color-picker-edit__input input {\n    border-style: solid;\n  }\n}\n.v-color-picker-edit__input span {\n  font-size: 0.75rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
